import { Spinner, Text } from "@chakra-ui/react";
import { Dispatch, MutableRefObject, SetStateAction, useEffect, useState } from "react";
import { formatUnits } from "viem";
import { Address, useAccount, useBalance } from "wagmi";

export default function BalanceAction({
  inputRef,
  setAmount,
  token,
  tokenName,
  tokenDecimals,
}: {
  inputRef?: MutableRefObject<any>;
  setAmount?: Dispatch<SetStateAction<bigint | undefined>>;
  token: Address | undefined;
  tokenName: string | undefined;
  tokenDecimals: number | undefined;
}) {
  const { address } = useAccount();
  const {
    data: balance,
    isError: isErrorBalance,
    isLoading: isLoadingBalance,
    isSuccess: isSuccessBalance,
  } = useBalance({
    token: token,
    address: address,
    watch: true,
    enabled: token != null && address != null,
  });

  const [displayBalance, setDisplayBalance] = useState<string | undefined>();
  useEffect(() => {
    if (balance && tokenDecimals) {
      setDisplayBalance(formatUnits(balance.value, tokenDecimals));
    }
  }, [balance, tokenDecimals]);

  return (
    <>
      {isLoadingBalance && <Spinner size="xs" />}

      {isErrorBalance && (
        <Text fontSize="xs" display="block">
          Error fetching {tokenName} balance.
        </Text>
      )}

      {isSuccessBalance &&
        balance &&
        displayBalance &&
        (balance.value > 0 ? (
          <Text
            color={inputRef ? "teal.500" : "gray.500"}
            fontSize="xs"
            fontStyle="italic"
            display="block"
            cursor={inputRef ? "pointer" : "default"}
            onClick={() => {
              if (inputRef && inputRef.current) {
                inputRef.current.value = displayBalance;
                if (setAmount) setAmount(balance.value);
              }
            }}
          >
            Available Balance: {displayBalance} {tokenName}
          </Text>
        ) : (
          <Text fontSize="xs" display="block">
            You do not have any {tokenName}.
          </Text>
        ))}
    </>
  );
}
